import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { DialogService, DialogRef, DialogCloseResult } from '@progress/kendo-angular-dialog';
import { NglModule} from 'ng-lightning';
import { FormsModule } from '@angular/forms';
import { RvService, AddDaysToDate } from '../../../core';
import { DateTime } from 'typescript-dotnet-es6/System/Time/DateTime'
import { IntlService } from '@progress/kendo-angular-intl';
import { AuditAvl_AuditSchedule } from '../../../core/models/AuditAvl_AuditSchedule-model'
import { RvGridComponent } from '../../../main/rate-avail/rv-grid/rv-grid.component';
@Component({
  selector: 'app-rvmodal',
   templateUrl: './rv_modal.component.html',
  styleUrls: ['./rv_modal.component.scss']
})
export class rv_modalComponent implements OnInit {
   @Output()  onrvCloseToParent = new EventEmitter<any>();
   @Output()  onrvOkToParent = new EventEmitter<any>();
   @Output()  rvonRefreshToParent = new EventEmitter<any>();
   @Input() dialogTitle:string;
   @Input() primaryButtonText:string;
   @Input() secondaryButtonText:string;
   @Input() auditID:any;
   @Input() auditName:any;
   @Input() auditProcessedWhen:any;
   @Input() AuditNotificationID:any;
   @Input() AuditScheduleID:any;

   public time:number;
   public notificationTemplateList:string[];
   public notificationTemplateID:any[];
   public Name;
   public auditDate:Date;
   public auditTime:Date;
   public radioRunAuditWhen="RunLater";
   public NotificationTemplateName;
   public NotificationTemplateSelectionID;
   public radioNotificationPackage;
   public auditDateTime:any=null;
   public AuditAvlObj: AuditAvl_AuditSchedule
        = {AuditID:" ",AuditScheduleID:" ",Name:" ",ProcessAuditWhen:null,AuditNotificationName:"",AuditNotificationID:"",SendNotifications:false, AuditContactEmailAddress:""};
   public isEnabled:boolean=false;
   earliestRunDate: Date;
   latestRunDate: Date;
   now: () => DateTime = () => DateTime.now;

  constructor(private dialogService: DialogService,private service: RvService,private intl: IntlService) {

    const now = this.now().date;
    this.earliestRunDate = this.now().date.toJsDate();
    this.latestRunDate = AddDaysToDate(now, 330).toJsDate();
  }

    public onSecondaryButtonClick() {
      this.onrvCloseToParent.emit();
    }

    public onTertiaryButtonClick() {
        this.onrvCloseToParent.emit();
    }

    public onPrimaryButtonClick() {

      this.Name=this.auditName;
      if( this.radioRunAuditWhen=="RunNow")
      {
          var now = new Date();
          this.auditDateTime= new Date(now.getFullYear(),now.getMonth(),now.getDate(),
                                                now.getHours(),now.getMinutes());
      }
      else if(this.radioRunAuditWhen=="RunLater")
      {
          if(!this.auditDate)
          {
            var dd=new Date(this.auditProcessedWhen).getDate();
            var mm=new Date(this.auditProcessedWhen).getMonth()+1;
            var yy=new Date(this.auditProcessedWhen).getFullYear();
            var newDate=yy+'/'+ mm +'/'+ dd;
            this.auditDate=new Date(newDate);
          }
          if(!this.auditTime)
          {
            var dd=new Date(this.auditProcessedWhen).getDate();
            var mm=new Date(this.auditProcessedWhen).getMonth()+1;
            var yy=new Date(this.auditProcessedWhen).getFullYear();
            var hh=new Date(this.auditProcessedWhen).getHours();
            var ms=new Date(this.auditProcessedWhen).getMinutes();
            var newTime=yy+'/'+ mm +'/'+ dd +' '+ hh +':'+ ms;
            this.auditTime=new Date(newTime);
          }
            var dd=new Date(this.auditDate).getDate();
            var mm=new Date(this.auditDate).getMonth();
            var yy=new Date(this.auditDate).getFullYear();
            var hh=new Date(this.auditTime).getHours();
            var ms=new Date(this.auditTime).getMinutes();
            var newdate=new Date(yy, mm, dd, hh, ms);
            this.auditDateTime=newdate;

        }
        this.AuditAvlObj.AuditID=this.auditID;
        this.AuditAvlObj.AuditScheduleID=this.AuditScheduleID;
        this.AuditAvlObj.Name=this.Name;
        this.AuditAvlObj.ProcessAuditWhen=this.auditDateTime;
        if(this.AuditNotificationID=="00000000-0000-0000-0000-000000000000" || this.AuditNotificationID==null){
          this.AuditAvlObj.AuditNotificationID="";
          this.NotificationTemplateName="";
          this.AuditAvlObj.AuditNotificationName=this.NotificationTemplateName;
          this.service.UpdateAudit(this.AuditAvlObj)
          .subscribe(data=>{
            let dis = this;
            setTimeout(()=>{
              dis.onrvOkToParent.emit();
            },2000);
          });
        }else{
          this.service.GetNotificationNameByID(this.AuditNotificationID).subscribe(data=>{
            this.NotificationTemplateName=data[0].Name;
            this.AuditAvlObj.AuditNotificationName=this.NotificationTemplateName;
            this.AuditAvlObj.AuditNotificationID=this.AuditNotificationID;
            this.service.UpdateAudit(this.AuditAvlObj)
            .subscribe(data=>{
              let dis = this;
              setTimeout(()=>{
                dis.onrvOkToParent.emit();
              },2000);
            },(err)=>console.log(err)); });
        }
    }

    onRunNowClick(){
      this.radioRunAuditWhen="RunNow";
      this.isEnabled=true;
    }

    onRunLaterClick(){
      this.radioRunAuditWhen="RunLater";
      this.isEnabled=false;
     }

    onDateChange(value: Date):void{
    this.auditDate=value;
     }

     onTimeChange(value:Date):void{
     this.auditTime=value;
     }


    public convertDateTomdyyyyFormat(date:Date){
      return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
      }


  ngOnInit() {

    this.service.GetNotificationTemplate().
    subscribe(data=>{
      this.notificationTemplateList=data;

    });

  }




}
